import * as THREE from 'three'

/**
 * 封装第三人称类
 */
export class CharacterControlsOther{
	

	constructor(player,mixer,animationsMap, currentAction){
		
		// this.raycaster = new THREE.Raycaster();

		this.model = player
		this.mixer = mixer
		this.animationsMap = animationsMap
		this.currentAction = currentAction
		this.animationsMap.forEach((value, key) => {
			//key Idle Run Walk
			// console.log("currentAction:"+currentAction)
			if (key == currentAction) {
				value.play()
			}
		})
		this.animationsMap.get(currentAction).play();


		// this.toggleRun = true
		// temporary data
		// this.walkDirection = new THREE.Vector3()
		//旋转的轴 y轴
		this.rotateAngle = new THREE.Vector3(0, 1, 0)
		// 四元数
		this.rotateQuarternion= new THREE.Quaternion()
		// this.cameraTarget = new THREE.Vector3()
		//动作切换时间
		// this.fadeDuration = 0.2
		//跑步速度
		// this.runVelocity = 500
		//走路速度w
		// this.walkVelocity = 200
		// this.DIRECTIONS = ['w', 'a', 's', 'd']
	}

	//动作更新
	update(delta, play, fromAxisAngle, x, z){
		//如果当前不是运动状态，就切换动画
		if (this.currentAction != play) {
			const toPlay = this.animationsMap.get(play)
			const current = this.animationsMap.get(this.currentAction)
			current.fadeOut(this.fadeDuration)
			toPlay.reset().fadeIn(this.fadeDuration).play();
			this.currentAction = play
		}
		this.mixer.update(delta)


		//计算运动的时候转向的角度
		if(this.currentAction =='run' || this.currentAction =='walk'){
			

			this.rotateQuarternion.setFromAxisAngle(this.rotateAngle, fromAxisAngle)

			//计算机器人旋转起来
			// q - 目标四元数 step - 以弧度为单位的角度步长
			this.model.quaternion.rotateTowards(this.rotateQuarternion, 0.2)

			//移动机器人
			this.model.position.x = x;
			this.model.position.z = z;
			this.model.position.y = 0;
		}
	}

}



// WEBPACK FOOTER //
// ./src/assets/js/CharacterControlsOther.js